module.exports = __webpack_public_path__ + "static/img/1.cf3a1a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/1.png
// module id = QgJq
// module chunks = 0